import React from "react";

const SPACES = [
  {
    title: "Salle de Rituel",
    desc: "Un espace sacré pour les cérémonies d'accueil et de transformation.",
    img: "https://images.pexels.com/photos/4880794/pexels-photo-4880794.jpeg",
    size: "md:col-span-2 md:row-span-2",
  },
  {
    title: "Jardin Intérieur",
    desc: "Une oasis de paix pour la méditation et la reconnexion.",
    img: "https://images.pexels.com/photos/35493571/pexels-photo-35493571.jpeg",
    size: "md:col-span-2",
  },
  {
    title: "Dortoirs",
    desc: "Des chambres sécurisées, chaleureuses, pour se reposer.",
    img: "https://images.unsplash.com/photo-1522771739844-6a9f6d5f14af?w=1200&q=80",
    size: "",
  },
  {
    title: "Cuisine Collective",
    desc: "Un lieu de partage et d'apprentissage culinaire.",
    img: "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=1200&q=80",
    size: "",
  },
];

export default function Espaces() {
  return (
    <section
      id="espaces"
      data-testid="espaces-section"
      className="bg-[#F2EBE1] py-24 lg:py-36"
    >
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="grid lg:grid-cols-12 gap-8 mb-14">
          <div className="lg:col-span-6">
            <p className="sdm-divider">Un lieu unique à Paris</p>
            <h2 className="font-serif-display text-4xl lg:text-6xl text-[#4A192C] mt-8 leading-tight">
              Les Espaces
              <br />
              <em className="text-[#C5A059]">du Sanctuaire.</em>
            </h2>
          </div>
          <p className="lg:col-span-6 text-[#2C1E23]/85 text-lg leading-relaxed self-end">
            Un bâtiment réhabilité dans le 9ᵉ arrondissement de Paris,
            transformé en temple de la dignité féminine. Quatre espaces
            modulables, pensés pour la guérison et la renaissance.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-3 auto-rows-[180px] md:auto-rows-[220px]">
          {SPACES.map((s, i) => (
            <div
              key={s.title}
              data-testid={`espace-${i + 1}`}
              className={`relative overflow-hidden group ${s.size}`}
            >
              <img
                src={s.img}
                alt={s.title}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#4A192C]/90 via-[#4A192C]/30 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-6 text-[#FAF7F2]">
                <h3 className="font-serif-display text-2xl lg:text-3xl">
                  {s.title}
                </h3>
                <p className="text-sm text-[#FAF7F2]/80 mt-2 max-w-sm">
                  {s.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
